import { render, staticRenderFns } from "./pollution.vue?vue&type=template&id=e4edafc2&"
import script from "./pollution.vue?vue&type=script&lang=js&"
export * from "./pollution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports